
import { createContext } from "react";
import { Article } from "../../constants";

export const FeatureArticleContext = createContext<FeatureArticleContextProps>({
    isMenuOpen: false,
    setIsMenuOpen: () => { },
    fontSize: 62.5,
    setFontSize: () => { },
    article: null,
    setArticle: () => { },
    toggleMenu: () => { },
})

interface FeatureArticleContextProps {
    isMenuOpen: boolean;
    setIsMenuOpen: (isOpen: boolean) => void;
    fontSize: number;
    setFontSize: (size: number) => void;
    article: Article | null;
    toggleMenu: Function;
    setArticle: (article: Article | null) => void;
}